//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";
import { mapActions, mapGetters } from "vuex";
import AQDropdown from "@/components/Generics/AQDropdown/AQDropdown.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import { APP_DATE_SLASH } from "@/assets/js/appConfig";
import FabricSearch from "@/components/q-fabric-search.vue";
import { setPluginIcon, eventBus } from "@/assets/js/appFunc";
import { TASKS_STATUS, TASKS_PRIORITY, TASKS_INSTANCE_STATUS,
    OPERATORS_VALUES, OPERATORS_BOOLEAN_VALUES, OPERATORS_ALL_VALUES, BOOLEAN_VALUES } from "./constants";

const transparentIcon = require("@/assets/images/transparentIcon24px.png");

export default {
    name: "CustomFiltersFields",
    components: {
        AQInput,
        AQDropdown,
        FabricSearch,
        AQTooltip,
        AQChip
    },
    props: {
        fieldConfig: { type: Object, default: () => ({}) },
        isReadOnly: { type: Boolean, default: false },
        filterLoaded: { type: Boolean, default: false },
        filterData: { type: Object, default: () => ({}) },
        fromTimeSelected: { type: String, default: "" },
        toTimeSelected: { type: String, default: "" },
        processIdActivities: { type: String, default: "" },
        pageType: { type: String, default: "" },
        inputAllActivities: { type: Array, default: () => [] },
        resetActivityField: { type: Boolean, default: false }
    },
    data() {
        return {
            searchValue: "",
            activityMod: [],
            statusesMod: [],
            instanceMod: [],
            fromDateTime: "",
            toDateTime: "",
            usersGroupsMod: [],
            searchAssigneesValue: "",
            priorityMod: [],
            someOptions: [{
                value: "Value",
                label: "Label"
            }],
            operatorMod: "",
            assigneesLoad: [],
            optionsBehaviour: OPERATORS_VALUES,
            optionsLongBehaviour: OPERATORS_ALL_VALUES,
            optionsBooleanBehaviour: OPERATORS_BOOLEAN_VALUES,
            optionsBoolean: BOOLEAN_VALUES,
            operatorDefaultValue: [{
                label: "==",
                value: "EQUAL",
                description: this.$t("liveView.filters.dataModelOperators.equals")
            }],
            dataModelForNow: [],
            inputDataModel: "",
            defaultBooleanValue: [],
            usersGroupsDataOptions: [],
            usersGroupsPayload: {
                searchValue: "",
                processDefinitionId: "",
                pagination: true,
                fromProcessInspector: true,
                pageNumber: 0,
                pageSize: 50
            },
            readonly: true,
            hasErrors: false,
            activitiesData: [],
            defaultActivityValue: "",
            defaultOperatorValue: [],
            statusesData: TASKS_STATUS,
            priorityData: TASKS_PRIORITY,
            instanceData: TASKS_INSTANCE_STATUS,
            defaultFiltersValue: "",
            dateTimeFormat: "DD.MM.YYYY HH:mm",
            timeFormat: "HH:mm",
            dateFormat: "DD.MM.YYYY",
            firstTimeCall: false,
            componentKey: 0,
            fieldFromDate: "",
            myLocaleRo: {
                days: "Du_Lu_Ma_Mi_Joi_Vi_Sâ".split("_"),
                daysShort: "Du_Lu_Ma_Mi_Joi_Vi_Sâ".split("_"),
                months: "Ian_Feb_Mar_Apr_Mai_Iun_Iul_Aug_Sep_Oct_Nov_Dec".split("_"),
                monthsShort: "Ian_Feb_Mar_Apr_Mai_Iun_Iul_Aug_Sep_Oct_Nov_Dec".split("_"),
                firstDayOfWeek: 1
            }
        };
    },
    computed: {
        ...mapGetters("main", ["getCurrentApplicationId"]),
        ...mapGetters("reports", ["getSelectedProcessReports"]),
        ...mapGetters("userProfile", ["userDataDetails"]),
        myLocale() {
            let localeToReturn = null;
            if (this.userDataDetails && this.userDataDetails.language === "ro") {
                localeToReturn = this.myLocaleRo;
            }
            return localeToReturn;
        },
        setFromDateProps() {
            return {
                options: this.optionsFromDate,
                noTimeOptions: true,
                locale: this.myLocale
            };
        },
        setToDateProps() {
            return {
                options: this.optionsToDate,
                noTimeOptions: true,
                locale: this.myLocale
            };
        },
        fieldType() {
            return this.fieldConfig.value;
        },
        isDataModel() {
            return !!this.fieldConfig.type;
        },
        isVisible() {
            return this.fieldConfig.visible;
        },
        getActivityProps() {
            return {
                label: this.$t("liveView.taskDetails.taskDescription"),
                options: this.activitiesData,
                emitValue: true
            };
        },
        getStatusesProps() {
            return {
                label: this.$t("liveView.filters.taskStatus"),
                options: this.statusesData,
                hasCheckbox: true,
                isMultiselect: true,
                emitValue: true,
                clearableChip: !this.isReadOnly
            };
        },
        getInstanceProps() {
            return {
                label: this.$t("dashboard.instanceStatus"),
                options: this.instanceData,
                hasCheckbox: true,
                isMultiselect: true,
                emitValue: true,
                clearableChip: !this.isReadOnly
            };
        },
        getUserGroupsProps() {
            return {
                label: this.$t("diagrams.components.variablesCard.users"),
                options: this.usersGroupsDataOptions,
                addSearch: true,
                hasAvatar: true,
                hasCheckbox: true,
                isMultiselect: true,
                hasPagination: true,
                clearableChip: true,
                sendAllData: true,
                popoverAnchorPosition: "bottom left",
                popoverSelfPosition: "top left"
            };
        },
        getPriorityProps() {
            return {
                label: this.$t("liveView.filters.taskPriorityTitle"),
                options: this.priorityData,
                hasCheckbox: true,
                isMultiselect: true,
                emitValue: true,
                clearableChip: !this.isReadOnly
            };
        },
        getChipProps() {
            return {
                textColor: "#FFFFFF",
                backgroundColor: "#BF4AE2;",
                fontSize: 8,
                fontWeight: 500,
                height: 18,
                lineHeight: 14
            };
        },
        getOperatorsProps() {
            return {
                options: this.optionsBehaviour,
                conditionalDDL: true,
                popoverAnchorPosition: "bottom left",
                popoverSelfPosition: "top left",
                emitValue: true
            };
        },
        getOperatorsLongProps() {
            return {
                options: this.optionsLongBehaviour,
                conditionalDDL: true,
                popoverAnchorPosition: "bottom left",
                popoverSelfPosition: "top left",
                emitValue: true
            };
        },
        getOperatorBooleanProps() {
            return {
                options: this.optionsBooleanBehaviour,
                conditionalDDL: true,
                popoverAnchorPosition: "bottom left",
                popoverSelfPosition: "top left",
                emitValue: true
            };
        },
        getBooleanProps() {
            return {
                placeholder: this.$t("dashboard.select"),
                readonly: this.isReadOnly,
                options: this.optionsBoolean,
                hasNormalState: this.isReadOnly,
                emitValue: true
            };
        }
    },
    watch: {
        inputAllActivities: {
            handler(newValue) {
                if (!this.pageType && newValue && newValue.length) {
                    this.activitiesData = newValue;
                }
            }
        },
        filterLoaded: {
            handler(value) {
                if (value) {
                    this.setFilterData(this.fieldConfig);
                }
            }
        },
        resetActivityField: {
            handler(value) {
                if (value && this.$refs.activityRef) {
                    this.$refs.activityRef.clearValue();
                }
            }
        },
        fieldConfig: {
            handler(filter) {
                this.setFilterData(filter);

                if (!this.pageType && filter.value === "activity" && this._isMounted
                    && this.processIdActivities && (!this.activitiesData || !this.activitiesData.length)) {
                    this.setActivityMod(this.processIdActivities);
                }
            },
            immediate: true,
            deep: true
        },
        searchAssigneesValue: {
            handler(value) {
                if (value) {
                    const searchV = value.trim();
                    if (searchV && searchV.length > 2) {
                        this.usersGroupsPayload.pageNumber = 0;
                        this.searchData(searchV);
                    }
                } else {
                    this.usersGroupsPayload.pageNumber = 0;
                    this.searchData();
                }
            }
        },
        processIdActivities: {
            handler(value) {
                if (value && this.fieldType === "activity") {
                    this.setActivityMod(value);
                }
            },
            immediate: true
        },
        pageType: {
            handler(value) {
                if (!value && this.processIdActivities && this.fieldType === "activity") {
                    this.setActivityMod(this.processIdActivities);
                }
            },
            immediate: true
        },
        "getSelectedProcessReports.searchPerspectives": {
            handler(newValue) {
                const { pageType, _inactive, fieldType } = this;
                if (pageType === "searchPerspectives" && !_inactive && fieldType === "assignees" && newValue && newValue.perspectiveId) {
                    this.firstTimeCall = true;
                    this.getUsersAndGroups();
                }
                if (pageType === "searchPerspectives" && !_inactive && fieldType === "activity" && newValue && newValue.id) {
                    this.setActivityMod(newValue.id);
                }
            },
            immediate: true,
            deep: true
        },
        fromTimeSelected: {
            handler(value) {
                if (this.fieldType === "toDate") {
                    if (value) {
                        const [nDate, nTime] = value.split(" ");
                        const [year, month, day] = nDate.split("-");
                        const [hours, minutes] = nTime.split(":");

                        const newDate = new Date(year, month - 1, day);
                        let offset = newDate.getTimezoneOffset();
                        offset = `${(offset < 0 ? "" : "-") + Math.floor(Math.abs(offset / 60))}`;
                        newDate.setHours(parseFloat(hours) + parseFloat(offset));
                        newDate.setMinutes(minutes);
                        this.fieldFromDate = date.formatDate(newDate, "YYYY-MM-DD HH:mm");
                    } else {
                        this.fieldFromDate = "";
                    }
                }
            },
            immediate: true
        }
    },
    mounted() {
        if (this.pageType === "reports" && this.fieldType === "assignees") {
            this.firstTimeCall = true;
            this.getUsersAndGroups();
        }
        if (this.fieldType === "search") {
            eventBus.$on("searchTasksAndInstances", data => {
                if (!this._inactive) {
                    this.searchValue = data;
                }
            });
        }
        const fromInputElement = this.$el.querySelector(".dateInput .q-field__native");
        if (fromInputElement) {
            fromInputElement.setAttribute("readonly", "readonly");
        }
    },
    methods: {
        ...mapActions("reports", ["getAllReportsActivities", "searchAllUsersGroups"]),
        setPluginIcon,
        forceRerender() {
            this.componentKey++;
        },
        setFilterData(filter) {
            const { value } = filter;
            if (value === "search") {
                const [filterValue] = filter.fieldValue;
                if (filter.fieldValue && this.searchValue !== filterValue.value) {
                    this.forceRerender();
                }
            } else {
                this.forceRerender();
            }
            if (filter.hasOwnProperty("fieldValue")) {
                const [filterSetup] = filter.fieldValue;

                if (filter.hasOwnProperty("className")) {
                    if (filter.type === "boolean") {
                        this.defaultBooleanValue = filterSetup.value && filterSetup.value.length ? [this.fieldConfig.fieldValue[0].value] : null;
                    } else {
                        this.inputDataModel = this.fieldConfig.fieldValue[0].value;
                    }
                    this.defaultOperatorValue = [this.fieldConfig.operator];
                    this.operatorMod = this.fieldConfig.operator;
                } else {
                    switch (value) {
                        case "search":
                            this.searchValue = filterSetup.value || "";
                            this.addSearchValue();
                            break;
                        case "activity":
                            if (this.$refs.activityRef) {
                                this.$refs.activityRef.clearValue();
                            }
                            this.defaultActivityValue = null;
                            if (filterSetup.value) {
                                this.defaultActivityValue = filterSetup.value;
                            }
                            break;
                        case "taskStatus":
                            if (this.$refs.statusesRef) {
                                this.$refs.statusesRef.clearValue();
                            }
                            this.defaultFiltersValue = null;
                            if (filterSetup.value.length) {
                                this.defaultFiltersValue = [...filterSetup.value];
                            }
                            this.selectFilter(filterSetup.value, "statuses");
                            break;
                        case "instanceStatus":
                            if (this.$refs.instanceRef) {
                                this.$refs.instanceRef.clearValue();
                            }
                            this.defaultFiltersValue = null;
                            if (filterSetup.value.length) {
                                this.defaultFiltersValue = [...filterSetup.value];
                            }
                            this.selectFilter(filterSetup.value, "instance");
                            break;
                        case "taskPriority":
                            if (this.$refs.priorityRef) {
                                this.$refs.priorityRef.clearValue();
                            }
                            this.defaultFiltersValue = null;
                            if (filterSetup.value.length) {
                                this.defaultFiltersValue = [...filterSetup.value];
                            }
                            this.selectFilter(filterSetup.value, "priority");
                            break;
                        case "fromDate":
                            this.fromDateTime = filterSetup.value ? this.setDateFromFilter(filterSetup.value) : "";
                            this.selectDateTime("from");
                            break;
                        case "toDate":
                            this.toDateTime = filterSetup.value ? this.setDateFromFilter(filterSetup.value) : "";
                            this.selectDateTime("to");
                            break;
                        case "assignees":
                            if (this.$refs.usersGroupsRef) {
                                this.$refs.usersGroupsRef.clearValue();
                            }
                            this.assigneesLoad = [...this.fieldConfig.fieldValue[0].value, ...this.fieldConfig.fieldValue[1].value];
                            if (this.assigneesLoad.length) {
                                this.getUsersAndGroups();
                                this.firstTimeCall = true;
                            }
                            break;
                        default:
                    }
                }
            }
        },
        searchItems() {
            this.$emit("searchTrigger");
        },
        addSearchValue() {
            const searchObject = {
                type: "search",
                value: this.searchValue
            };
            this.$emit("update:filterData", searchObject);
        },
        optionsToDate(data) {
            let valid = true;
            if (this.fieldFromDate) {
                const newDate = date.formatDate(this.fieldFromDate, APP_DATE_SLASH);
                valid = data >= newDate;
            }
            return valid;
        },
        optionsFromDate(data) {
            let valid = true;
            if (this.toTimeSelected) {
                const newDate = date.formatDate(this.toTimeSelected, APP_DATE_SLASH);
                valid = data <= newDate;
            }
            valid = data >= "1970/01/01";
            return valid;
        },
        deleteDataModel() {
            this.$emit("deleteDMFilter", this.fieldConfig.formatted);
        },
        selectFilter(event, filterType) {
            const filterObject = {
                type: filterType,
                value: [...event]
            };
            if (filterType === "statuses") {
                eventBus.$emit("selectStatusFromDDL");
            }
            this.$emit("update:filterData", filterObject);
        },
        selectDateTime(dateType) {
            const dateValue = dateType === "from" ? this.fromDateTime : this.toDateTime;
            const dateObject = {
                type: dateType,
                value: dateValue ? this.formatTimeToSend(dateValue) : ""
            };
            this.$emit("update:filterData", dateObject);
        },
        formatTimeToSend(data) {
            let dataCopy = data;
            if (data.includes("+000")) {
                dataCopy = data.substring(0, data.length - 5);
            }

            const dateObj = new Date(dataCopy);
            const newDate = new Date(dateObj.getTime() + dateObj.getTimezoneOffset() * 60 * 1000);
            return date.formatDate(newDate, "YYYY-MM-DD HH:mm");
        },
        selectActivity(event) {
            const activityObject = {
                type: "activity",
                value: ""
            };
            if (event !== "all_activities") {
                activityObject.value = event;
            } else {
                this.$refs.activityRef.clearValue();
            }
            eventBus.$emit("selectStatusFromDDL");
            this.$emit("update:filterData", activityObject);
        },
        setActivityMod(id) {
            this.getAllReportsActivities(id).then(data => {
                this.activitiesData = [{
                    label: this.$t("generic.clear"),
                    value: "all_activities",
                    svgIcon: { name: transparentIcon, size: "16px" }
                }];
                const activitiesDataFromCall = data.map(elem => ({
                    label: elem.activityLabel,
                    value: elem.activityId,
                    svgIcon: { name: this.setPluginIcon({ pluginType: elem.activityType }), size: "16px" }
                }));
                this.$emit("activitiesLoaded", data);
                this.activitiesData = this.activitiesData.concat(activitiesDataFromCall);
                if (!this.pageType) {
                    this.$emit("allActivities", this.activitiesData);
                }
            });
        },
        setDateFromFilter(data) {
            let formatedDate;
            if (data) {
                const [nDate, nTime] = data.split(" ");
                const [year, month, day] = nDate.split("-");
                const [hours, minutes] = nTime.split(":");

                const newDate = new Date(year, month - 1, day);
                let offset = newDate.getTimezoneOffset();
                offset = `${(offset < 0 ? "" : "-") + Math.floor(Math.abs(offset / 60))}`;
                newDate.setHours(parseFloat(hours) + parseFloat(offset));
                newDate.setMinutes(minutes);
                formatedDate = date.formatDate(newDate, "YYYY-MM-DDTHH:mm:ss.SSSZ");
            }
            return formatedDate;
        },
        setTimeFormat(type) {
            const dateFormat = type === "datetime" ? "dateTime" : type;
            return this[`${dateFormat}Format`];
        },
        hideUserGroupsDDL() {
            this.searchAssigneesValue = "";
        },
        getSearchValue(value) {
            this.searchAssigneesValue = value;
        },
        showResults() {
            this.optionsMenu = this.$refs.usersGroupsRef.$refs.menuDropdown.$refs.aqMenuOptionsRef.$el;

            this.optionsMenu.addEventListener("scroll", () => {
                if (this.optionsMenu.offsetHeight + this.optionsMenu.scrollTop >= this.optionsMenu.scrollHeight) {
                    this.searchData(null, true);
                }
            });
            this.usersGroupsPayload.pageNumber = 0;
            this.searchData();
        },
        searchData(value, loadMore) {
            this.usersGroupsPayload.searchValue = value || "";
            this.usersGroupsPayload.pageSize = 50;
            if (loadMore) {
                this.usersGroupsPayload.pageNumber++;
                this.getUsersAndGroups(loadMore);
            } else {
                this.getUsersAndGroups();
            }
        },
        getUsersAndGroups(loadMore) {
            this.usersGroupsPayload.processDefinitionId = this.getCurrentApplicationId;
            if (this.pageType === "searchPerspectives") {
                this.usersGroupsPayload.perspectiveId = this.getSelectedProcessReports[this.pageType].perspectiveId;
            }
            this.$store.dispatch("admin/getMembersLoadSearch", this.usersGroupsPayload).then(
                data => {
                    this.setUsersGroups(data, loadMore);
                    if (this.firstTimeCall) {
                        const usersGroupsIds = [...this.fieldConfig.fieldValue[0].value, ...this.fieldConfig.fieldValue[1].value];
                        if (usersGroupsIds.length) {
                            this.searchAllUsersGroups(usersGroupsIds).then(response => {
                                this.setUsersGroups(response);
                                this.usersGroupsMod = this.usersGroupsDataOptions;
                                this.selectAssignees();
                                this.firstTimeCall = false;
                            });
                        }
                        this.firstTimeCall = false;
                    }
                }
            );
        },
        buildGroupOption(elem) {
            const returnParams = {};
            const elementGroups = parseInt(elem.nrOfGroups, 10);
            const elementUser = parseInt(elem.nrOfUsers, 10);
            let type = "";
            let groupsInfo = "";
            let nrGroups = "";
            let nrUsers = "";

            if (elem.sourceType === "AD" || elem.systemType === "EXTERNAL") {
                type = "externalGroup";
            } else if (elem.systemType === "APPLICATION") {
                type = "applicationSpecific";
            } else {
                type = "platform";
            }
            if (elem.nrOfGroups && elementGroups) {
                nrGroups = this.$tc("dashboard.nrOfGroups", elementGroups, { count: elementGroups });
            }
            if (elem.nrOfUsers && elementUser) {
                nrUsers = this.$tc("dashboard.nrOfUsers", elementUser, { count: elementUser });
            }
            if (elem.nrOfGroups && elementGroups && elem.nrOfUsers && elementUser) {
                groupsInfo = `${nrGroups} ${this.$t("admin.usersAndRoles.and")} ${nrUsers} `;
            } else if (elem.nrOfGroups && elementGroups && elem.nrOfUsers && !elementUser) {
                groupsInfo = nrGroups;
            } else if (elem.nrOfGroups && !elementGroups && elem.nrOfUsers && elementUser) {
                groupsInfo = nrUsers;
            }
            const isDisabled = (elem.status === "DISABLED");

            returnParams.label = elem.name;
            returnParams.description = groupsInfo;
            returnParams.avatarProps = { type, avatarDisabled: isDisabled };
            returnParams.elementType = "group";
            returnParams.value = elem.id;

            return returnParams;
        },
        buildUserOption(elem) {
            const returnParams = {};
            let userName = "";
            let path = null;
            let type = "";

            if (elem.systemType === "TOAUTHUSR") {
                type = "systemExternalUser";
            } else if (elem.systemType === "TSYS") {
                type = "systemInternalUser";
            } else {
                path = (elem && elem.avatar) ? `/identity/tenants/users/image/${elem.id}/s` : null;
                type = (elem.sourceType === "AD" || elem.systemType === "TSAMLUSR" || elem.realmId) ? "externalUser" : "userPlatform";
            }
            if (elem.name && elem.lastName) {
                if (elem.systemType === "TOAUTHUSR") {
                    const externalCode = elem.code ? ` [${elem.code}] ` : " ";
                    userName = elem.name.concat(externalCode, elem.lastName);
                } else {
                    userName = elem.name.concat(" ", elem.lastName);
                }
            } else if (!elem.name) {
                userName = elem.lastName;
            } else if (!elem.lastName) {
                userName = elem.name;
            }
            const isDisabled = (elem.status === "DISABLED");
            returnParams.label = userName || elem.email;
            returnParams.description = userName ? elem.email : "";
            returnParams.avatarProps = { type, avatarDisabled: isDisabled, customAvatar: path };
            returnParams.elementType = "user";
            returnParams.value = elem.id;

            return returnParams;
        },
        setUsersGroups(data, loadMore) {
            const peopleList = data.map(elem => {
                let returnParams = {};
                if (elem.type === "GROUP") {
                    returnParams = { ...this.buildGroupOption(elem) };
                } else if (elem.type === "USER") {
                    returnParams = { ...this.buildUserOption(elem) };
                }
                return returnParams;
            });
            if (loadMore) {
                this.usersGroupsDataOptions = this.usersGroupsDataOptions.concat(peopleList);
            } else {
                this.usersGroupsDataOptions = [];
                this.usersGroupsDataOptions = peopleList;
            }
        },
        selectAssignees(evt) {
            this.groupsIds = [];
            this.usersIds = [];
            let groupSelect = [];
            let userSelect = [];

            if (evt && !evt.length) {
                this.groupsIds = [];
                this.usersIds = [];
            } else if (evt && evt.length) {
                groupSelect = evt.filter(elem => elem.elementType === "group");
                this.groupsIds = groupSelect.map(elem => elem.value);
                userSelect = evt.filter(elem => elem.elementType === "user");
                this.usersIds = userSelect.map(elem => elem.value);
            } else if (!evt && this.usersGroupsMod.length) {
                const groups = this.usersGroupsMod.filter(elem => elem.elementType === "group");
                this.groupsIds = groups.map(elem => elem.value);
                const users = this.usersGroupsMod.filter(elem => elem.elementType === "user");
                this.usersIds = users.map(elem => elem.value);
            }

            const assigneeObject = {
                type: "assignee",
                users: this.usersIds,
                groups: this.groupsIds
            };
            this.$emit("update:filterData", assigneeObject);
        },
        selectOperator(event) {
            this.operatorMod = event;
            const modelObject = {
                type: "dataModel",
                key: this.fieldConfig.formatted,
                value: this.inputDataModel,
                operator: this.operatorMod
            };
            this.$emit("update:filterData", modelObject);
        },
        setErrorMessage(type) {
            return this.$t(`dashboard.${type}ErrorMessage`);
        },
        addModelInput(type, event) {
            if (type === "boolean") {
                this.inputDataModel = event;
            } else if (type === "input") {
                const regexInteger = /^(|-?\d+)$/;
                const regexDecimal = /^[-+]?(\d+\.?\d{0,9}|\.\d{1,9})$/;
                let hasErrors = false;
                if (this.inputDataModel) {
                    if (this.fieldConfig === "integer") {
                        hasErrors = !regexInteger.test(this.inputDataModel);
                    } else if (this.fieldConfig.type === "decimal") {
                        hasErrors = !regexDecimal.test(this.inputDataModel);
                    }
                }
                this.hasErrors = hasErrors;
                this.$emit("dataModelFilterErrors", this.hasErrors);
            }
            const modelObject = {
                type: "dataModel",
                key: this.fieldConfig.formatted,
                value: this.inputDataModel,
                operator: this.operatorMod || "EQUAL"
            };
            this.$emit("update:filterData", modelObject);
        }
    }
};
